import CMSAPI from "@/services/api/contentManagmentApi";
import draggable from "vuedraggable";
import algoliaSearch from "algoliasearch/lite";

const { getCollectionsCarousel, updateCollectionsCarousel, uploadFile } = new CMSAPI();

export default {
  components: {
    draggable,
  },
  data() {
    return {
      algoliaClient: algoliaSearch(this.$env.algolia().appId, this.$env.algolia().token, {
        timeouts: {
          connect: this.$utils.constants.ALGOLIA_CONNECT_TIMEOUT,
          read: this.$utils.constants.ALGOLIA_READ_TIMEOUT,
        },
      }),
      collectionList: [],
      showAddCollection: false,
      allCollectionsList: null,
      perfectForTheTitle: "Perfect for the ",
    };
  },
  mounted() {
    this.searchIndexCollections = this.algoliaClient.initIndex(this.$env.getOrigin() + "_collections");
    getCollectionsCarousel(false).then(({ data }) => {
      const { view_components, name } = data;
      if (name) {
        this.perfectForTheTitle = name;
      }
      this.collectionList = view_components;
    });
  },
  methods: {
    selectImage,
    handleFileUpload,
    removeCollection,
    handleAddCollectionClick,
    handleSelectChange,
    handleSave,
    buildCollectionListCallback,
  },
};

function removeCollection(index) {
  this.collectionList.splice(index, 1);
}

function handleSelectChange(event) {
  const duplicate = this.collectionList.filter((collection) => collection.entity_id === event.target.value);

  if (duplicate && duplicate.length) {
    this.$swal("Attention", "This Collection is already in the Perfect For The list");
    return;
  }

  // eslint-disable-next-line one-var
  const selectedCollectionData = this.allCollectionsList.filter(
    (collection) => collection.id === event.target.value
  )[0];

  this.collectionList.push(selectedCollectionData);
  this.showAddCollection = false;
}

function handleAddCollectionClick() {
  if (this.allCollectionsList === null) {
    this.searchIndexCollections.clearCache();
    this.searchIndexCollections
      .search({
        hitsPerPage: 1000,
        facets: "active",
        facetFilters: ["active:true"],
      })
      .then((response) => {
        this.allCollectionsList = response.hits.map((hit) => ({
          title: hit.title,
          homepage_title: "",
          id: hit.id,
          entity_id: hit.id,
          image_url: hit.image_url,
        }));
      });

    this.showAddCollection = true;
  } else {
    this.showAddCollection = true;
  }
}

function buildCollectionListCallback(payload) {
  this.allCollectionsList = payload;
  this.showAddCollection = true;
}

function selectImage(index) {
  this.$refs[`fileUpload${index}`][0].click();
}

function handleFileUpload(i, files) {
  this.$notify.$emit("fire", {
    message: "uploading image..",
    type: "working",
  });

  const formData = new FormData();

  formData.append("file", files[0]);

  uploadFile(formData).then((response) => {
    this.collectionList[i].image_url = response.data.url;
    this.$notify.$emit("update", "Image Upload complete..");
    const timeout = 350;
    setTimeout(() => this.$notify.$emit("close", true), timeout);
  });
}

function handleSave() {
  let images = true;

  this.collectionList.forEach((item) => {
    if (!item.image_url) {
      images = false;
    }
  });

  if (!images) {
    this.$swal("Attention", "All Pefrect For The items must contain an image");
    return;
  }

  updateCollectionsCarousel({
    name: this.perfectForTheTitle,
    view_components: this.collectionList.map((component, i) => ({
      component_type: "COLLECTION",
      entity_id: component.entity_id,
      ordinal: i + 1,
      attributes: {
        image_url: component.image_url,
        homepage_title: component.homepage_title ? component.homepage_title : component.title,
        title: component.title,
      },
    })),
  })
    .then(() => this.$swal("Success: Perfect For The Saved"))
    .catch((error) =>
      error.response
        ? this.$swal("Attention", error.response.data.error_message)
        : this.$logger.notify(new Error(error))
    );
}
